
import { getFundReport, listDataFundReport } from '@/zsm-api-new/fund.js'
import { getFund, incomeListFund, withdrawFund, withdrawList, dataAnalysis } from '@/zsm-api-new/fund.js'
import { getFundUser, getListDataIntervalFundUser, withdrawFundUser, listLogFundUser, getFundUserByUserId, findFreezeList, unfreezeApply } from '@/zsm-api-new/fund.js'
const state = {
  overviewOrder: [] // 数据管理订单相关
}

const mutations = {
// 数据管理订单相关
  CHANGE_OVERVIEW_ORDER(state, data) {
    console.log(data)
    state.overviewOrder = data ? data.dealList : []
  }
}
const actions = {
  /**
   *  讲师数据分析
   *  loginCode 登录账号
   *  afterDate 结束日期
   *  beforeDate   开始日期
   */
  dataAnalysis({ commit }, data) {
    return new Promise((resolve, reject) => {
      dataAnalysis(data).then(response => {
        commit('CHANGE_OVERVIEW_ORDER', response.data.deal)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   *  查看某人的资金冻结记录
   *  id 解封的编号
   *  unfreezeApplyReason 申请解冻原因
   *  unfreezeApplyVoucher   申请解冻凭证
   *  unfreezeApplyDate   申请解冻时间
   */
  unfreezeApply({ commit }, data) {
    return new Promise((resolve, reject) => {
      unfreezeApply(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   *  查看某人的资金冻结记录
   *  userId 用户账号id
   *  beginDate 开始时间
   *  endDate   结束时间
   *  punishType //类型
   * pageNo 当前页
   * pageSize 每页条数
   */
  findFreezeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      findFreezeList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   *  某人的资金日志（新）根据开始时间结束时间查询统计数据
   *  @param {String} userId  登录账号
   *  @param {Date}  startDate 开始时间
   *  @param {Date}  endDate 结束时间
   */
  getFundUserByUserId({ commit }, data) {
    return new Promise((resolve, reject) => {
      getFundUserByUserId(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   *  提现（新/总数据）
   *  bankId 银行卡编号
   *  loginCode 登录账号
   *  fee 提现金额
   */
  withdrawFundUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      withdrawFundUser(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   *  用户的资金日志（新/总数据）
   *  loginCode 登录账号
   */
  listLogFundUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      listLogFundUser(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   *  某人的资金信息（新/总数据）
   *  id 用户账号id
   */
  getFundUser({ commit }, id) {
    return new Promise((resolve, reject) => {
      getFundUser(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   *  某人某个时间段的统计数据
   *  afterDate 开始时间
   *  beforeDate 结束时间
   *  loginCode 用户登录账号
   */
  getListDataIntervalFundUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      getListDataIntervalFundUser(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取某人某个时间段内的数据
  listDataFundReport({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataFundReport(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取某人某天资金数据
  getFundReport({ commit }, info) {
    return new Promise((resolve, reject) => {
      getFundReport(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 个人资金信息
  getFund({ commit }, id) {
    return new Promise((resolve, reject) => {
      getFund(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 讲师收益列表
  incomeListFund({ commit }, info) {
    return new Promise((resolve, reject) => {
      incomeListFund(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 提现
  withdrawFund({ commit }, info) {
    return new Promise((resolve, reject) => {
      withdrawFund(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 提现记录
  withdrawList({ commit }, info) {
    return new Promise((resolve, reject) => {
      withdrawList(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
